<template>
  <v-chip style="width: 100%; max-width: 220px; margin-right: 4px"
          :label="xs"
          :small="xs"
          :color="`${theme.elements.btnColor} ${trigger ? ' darken-1' : ''}`"
          @click="$emit('click')">
    <v-icon left
            :color="'white'"> mdi-checkbox-{{ trigger ? 'marked-circle' : 'blank-circle' }} </v-icon>
    <span class="pr-2"
          :class="theme.elements.btnTextClz">{{ $t(textKey) }}</span>
  </v-chip>
</template>

<script>
import commonMixin from '@/mixins/common';
export default {
  name: 'CheckboxChip',
  mixins: [commonMixin],
  props: {
    textKey: {
      type: String,
    },
    trigger: {
      type: Boolean,
    },
  },
};
</script>
